import { mergeStyleSets } from '@uifabric/merge-styles';
import get from 'lodash/get';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  filterItem: {
    paddingTop: pxToRem(6),
    paddingBottom: pxToRem(6),
    paddingRight: pxToRem(10),
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
    fontFamily: get(theme, 'fonts.small.fontFamily'),
    fontSize: pxToRem(14),
    lineHeight: pxToRem(24),
  },
  infoIcon: {
    verticalAlign: 'middle',
    fontSize: pxToRem(16),
    paddingRight: pxToRem(6),
  },
  filterDimension: {
    textDecoration: 'none',
  },
});
